// ABOUTME: Pre-display block under the Create Batch product search.
// ABOUTME: Lists products with a high count of open single-line orders for the current filters.
import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

import { tokens } from "../../../../../theme";
import { useGetProductsSelectQuery } from "../../../../../newapi/warehouse/productSlice";
import Text from "../../../../theme/text/Text";
import { ProductOpenSinglesItem } from "./ProductOpenSinglesItem";

const MIN_OPEN_SINGLES = 20;

export const ProductOpenSinglesPreview = ({ filterBody, product, setOptionMap }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const { warehouseId, relation, stream, reachtype, shipper, warehousezone } = filterBody ?? {};

    const { data } = useGetProductsSelectQuery({
        warehouseId,
        relation,
        stream,
        reachtype,
        shipper,
        warehousezone,
        ...(relation > -1 ? { relationId: relation } : {}),
        openSingles: true,
        minOpenSingles: MIN_OPEN_SINGLES,
    }, {
        skip: !warehouseId || warehouseId < 1,
    });

    const toggleProduct = (option) => {
        setOptionMap(prev => {
            const exists = prev.product.some(p => p.id === option.id);
            return {
                ...prev,
                product: exists
                    ? prev.product.filter(p => p.id !== option.id)
                    : [...prev.product, option],
            };
        });
    };

    if (!data || data.length === 0) {
        return null;
    }

    return (
        <Box
            sx={{
                mt:1.5,
                maxHeight:200,
                mx:1.5,
                overflow:"auto",
                background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[100],
                display:"flex",
                flexDirection:"column",
                gap:1,
                px:1.5,
                py:1.5,
                borderRadius:3,
            }}
        >
            <Text
                bold
                sx={{
                    pb:1.5,
                }}
            >
                {t("products_with_open_singles")}
            </Text>
            {data.map((option) => (
                <ProductOpenSinglesItem
                    key={"single-prod"+option.id}
                    option={option}
                    isSelected={product?.some(p => p.id === option.id)}
                    onClick={() => toggleProduct(option)}
                    radius={4}
                    background={theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0]}
                    pillRadius={3}
                    pillBackground={theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[100]}
                />
            ))}
        </Box>
    );
};
